// extracted by mini-css-extract-plugin
export default {"container":"BurgerContent_container__4LIOF"};